﻿import { DiscretePalette, GDFPalletCode } from '@fe/weather';
import React from 'react';

function DiscreteBarVertical({ data, showLabels }: { data: DiscretePalette; showLabels: boolean }) {
    const { name, units, values: reversedValues, colors, suffix } = data;
    const values = [...reversedValues].reverse();
    const [maxTextWidth, setMaxTextWidth] = React.useState<number>(0);
    const rectWidth = 15;
    const rectHeight = 15;
    const totalSegments = colors.length;
    const barHeight = totalSegments * rectHeight;
    const textRefs = React.useRef<Array<SVGTextElement | null>>([]);
    const svgRef = React.useRef<SVGSVGElement | null>(null);

    // Measure the width of the longest label
    React.useEffect(() => {
        if (textRefs.current.length > 0) {
            let widths = textRefs.current.map((text) => (text ? text.getBBox().width : 0));
            widths = widths.filter((width) => width > 0);

            const maxWidth = Math.max(...widths) + 6; // + padding left-right
            setMaxTextWidth(maxWidth);
        }
    }, [values]);

    let labelOffset = units ? 0 : 8;
    if (values.length >= totalSegments + 1 && values[0] !== null) {
        labelOffset += 8;
    }
    const svgHeight = barHeight + labelOffset + 8; // + padding bottom

    // Calculate positions for labels
    const labelPositions = values.map((value, index) => {
        if (value === null || value === undefined) {
            return null;
        }
        return {
            value,
            y:
                labelOffset +
                ((index + Number(values.length === totalSegments - 1) + Number(values.length === totalSegments)) / totalSegments) *
                    barHeight -
                (index === 0 ? 0 : 0)
        };
    });

    return (
        <div className={'legend-entry'}>
            <div style={{ fontSize: 12 }}>
                {name}
                {import.meta.env.DEV && (
                    <span>
                        {' '}
                        (0x{data.id.toString(16)} {GDFPalletCode[data.id]})
                    </span>
                )}
            </div>
            {units && <span style={{ fontWeight: '500', fontSize: 10 }}>{units}</span>}
            <svg ref={svgRef} width={rectWidth + maxTextWidth + 5} height={svgHeight} style={{ display: 'block' }}>
                {/* Color Segments */}
                {colors
                    .slice()
                    .reverse()
                    .map((color, index) => (
                        <rect key={index} x={0} y={index * rectHeight + labelOffset} width={rectWidth} height={rectHeight} fill={color} />
                    ))}

                {/* Labels */}
                {showLabels &&
                    labelPositions.map((label, index) => {
                        if (!label) {
                            return null;
                        }
                        return (
                            <text
                                key={index}
                                ref={(el) => {
                                    textRefs.current[index + 1] = el;
                                }}
                                x={rectWidth + 5}
                                y={label.y}
                                textAnchor="start"
                                alignmentBaseline="middle"
                                fontSize="10"
                                fill={'var(--text-color)'}>
                                {label.value}
                                {suffix}
                            </text>
                        );
                    })}
            </svg>
        </div>
    );
}

export default DiscreteBarVertical;
